var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", {
        staticStyle: { position: "relative" },
        attrs: {
          subtitle:
            "Manage monitoring locations and assign data sources to them.",
          "no-padding": "",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "pa-3 card-bg-2", attrs: { row: "", wrap: "" } },
            [
              _c("v-hover", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ hover }) {
                      return _c(
                        "v-card",
                        {
                          staticClass: "clickable mr-3",
                          class: [hover ? "elevation-3" : "elevation-1"],
                          on: {
                            click: function ($event) {
                              return _vm.showEmptyLocations()
                            },
                          },
                        },
                        [
                          _c("v-card-text", { staticClass: "card-bg-1" }, [
                            _c(
                              "div",
                              { staticClass: "secondary--text" },
                              [
                                _vm._v(
                                  "\n              Empty Monitoring Locations\n              "
                                ),
                                _c("Tooltip", {
                                  attrs: {
                                    color: "primary",
                                    small: "",
                                    text: "These locations are not shown in the side menu because they have no data types assigned.",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "headline",
                                class: [
                                  _vm.emptyLocationsLength > 0
                                    ? "error--text"
                                    : "success--text",
                                ],
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.emptyLocationsLength) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      )
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("v-hover", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ hover }) {
                      return _c(
                        "v-card",
                        {
                          staticClass: "clickable",
                          class: [hover ? "elevation-3" : "elevation-1"],
                          on: {
                            click: function ($event) {
                              return _vm.showUnassigned()
                            },
                          },
                        },
                        [
                          _c("v-card-text", { staticClass: "card-bg-1" }, [
                            _c(
                              "div",
                              { staticClass: "secondary--text" },
                              [
                                _vm._v(
                                  "\n              Unassigned Data Sources\n              "
                                ),
                                _c("Tooltip", {
                                  attrs: {
                                    color: "primary",
                                    small: "",
                                    text: "To view data for these data sources, please assign them to a location. <br/> Only one type of data type can be present at one location",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "headline",
                                class: [
                                  _vm.unassignedLength > 0
                                    ? "error--text"
                                    : "success--text",
                                ],
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.unassignedLength) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      )
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-tabs",
            {
              attrs: {
                dark: "",
                "active-class": "tabs-active-tab",
                "slider-color": "info",
              },
              model: {
                value: _vm.currentViewType,
                callback: function ($$v) {
                  _vm.currentViewType = $$v
                },
                expression: "currentViewType",
              },
            },
            _vm._l(_vm.VIEW_TYPES, function (viewType, index) {
              return _c(
                "v-tab",
                {
                  key: `viewType-${index}`,
                  attrs: { href: `#${viewType.value}` },
                },
                [
                  _c("v-icon", { staticClass: "mr-2" }, [
                    _vm._v(_vm._s(viewType.icon)),
                  ]),
                  _vm._v("\n        " + _vm._s(viewType.text) + "\n      "),
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("ViewMonitoringFeatures", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.currentViewType ==
                  _vm.VIEW_TYPES.monitoringFeatures.value,
                expression:
                  "currentViewType == VIEW_TYPES.monitoringFeatures.value",
              },
            ],
            ref: "viewMonitoringFeatures",
            attrs: { search: _vm.search },
          }),
          _vm._v(" "),
          _c("ViewDataSources", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentViewType == _vm.VIEW_TYPES.dataSources.value,
                expression: "currentViewType == VIEW_TYPES.dataSources.value",
              },
            ],
            ref: "viewDataSources",
            attrs: {
              unassignedLength: _vm.unassignedLength,
              search: _vm.search,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }